var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasportatil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03271 12.2478C1.48043 12.2478 1.03271 11.8001 1.03271 11.2478V11.2478C1.03271 10.6955 1.48043 10.2478 2.03271 10.2478H9.3335C9.88578 10.2478 10.3335 10.6955 10.3335 11.2478V11.2478C10.3335 11.8001 9.88578 12.2478 9.3335 12.2478H2.03271Z",
    fill: "#7341B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2317 6.2478H2.93091C2.37862 6.2478 1.93091 6.69552 1.93091 7.2478C1.93091 7.80009 2.37862 8.2478 2.93091 8.2478H10.2317C10.784 8.2478 11.2317 7.80009 11.2317 7.2478C11.2317 6.69552 10.784 6.2478 10.2317 6.2478Z",
    fill: "#7341B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04443 16.4413C3.49215 16.4413 3.04443 15.9936 3.04443 15.4413V15.4413C3.04443 14.889 3.49215 14.4413 4.04443 14.4413H8.3772C8.92948 14.4413 9.3772 14.889 9.3772 15.4413V15.4413C9.3772 15.9936 8.92948 16.4413 8.3772 16.4413H4.04443Z",
    fill: "#7341B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25122 16.4413C0.702711 16.4413 0.258057 15.9898 0.258057 15.4413V15.4413C0.258057 14.8928 0.702711 14.4413 1.25122 14.4413V14.4413C1.79973 14.4413 2.24438 14.8928 2.24438 15.4413V15.4413C2.24438 15.9898 1.79973 16.4413 1.25122 16.4413V16.4413Z",
    fill: "#7341B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4766 8.07332L12.6684 20.7297C12.5958 21.2377 12.7965 21.4967 13.3175 21.5711L16.5201 22.0287C17.0125 22.0991 17.2889 21.8995 17.3567 21.4246C17.547 20.0926 18.9495 10.2764 19.1396 8.9458L19.1685 8.74365L14.4766 8.07332Z",
    stroke: "#7341B5",
    strokeWidth: 1.73629
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5494 7.60184L19.2109 8.26783C19.3059 7.60281 19.4666 6.94939 19.4763 6.29215C19.485 5.44625 18.8173 4.75653 17.9743 4.61835C17.4763 4.53944 16.9726 4.44529 16.4739 4.44944C16.0639 4.46108 15.6713 4.6139 15.3639 4.88153C15.0566 5.14917 14.8537 5.51482 14.7903 5.91538C14.6986 6.47109 14.631 7.03027 14.5494 7.60184Z",
    stroke: "#7341B5",
    strokeWidth: 1.73629
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0469 3.45228C19.105 3.04548 18.8223 2.66858 18.4155 2.61046L17.3106 2.45261C16.9038 2.39449 16.5269 2.67715 16.4688 3.08395L16.3636 3.82054L18.9416 4.18886L19.0469 3.45228Z",
    fill: "#7341B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.83641,
    height: 1.11609,
    rx: 0.372031,
    transform: "matrix(-0.989947 -0.141435 -0.141435 0.989947 20.5198 1.03223)",
    fill: "#7341B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasportatil);
export default __webpack_public_path__ + "static/media/gasportatil.0f2c0b9f5878dc6a236bf9c7b4006ba2.svg";
export { ForwardRef as ReactComponent };